import { AnimatePresence } from "framer-motion"
import { useAppSelector } from "appRedux/hooks"
import { useGetFollowRequestsQuery } from "appRedux/slices/userApiSlice"
import Divider from "components/atoms/Divider"
import FollowRequestNotification from "components/molecules/Notification/FollowRequestNotification"
import LayoutFadeAnimation from "components/animations/LayoutFadeAnimation"

export default function NewConnectionsPage() {
  const followRequests = useAppSelector((state) => state.user.followRequests)

  useGetFollowRequestsQuery(undefined, {
    refetchOnMountOrArgChange: true
  })

  return (
    <AnimatePresence>
      {followRequests.map((notif, index) => (
        <LayoutFadeAnimation
          key={index}
          style={{ marginTop: index === 0 ? "-8px" : "" }}
        >
          <FollowRequestNotification notification={notif}/>
          {index < followRequests.length - 1 && <Divider isFullWidth={true}/>}
        </LayoutFadeAnimation>
      ))}
    </AnimatePresence>
  )
}
